import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material';

import { SeriesInstance } from '../../objects/series-instance';
import { InstanceService } from '../../services/instance.service';

//This is a dependency of the Proton Xpress App Module
@Component({
  selector: 'edit-series',
  templateUrl: './edit-series.component.html',
  styleUrls: ['./edit-series.component.scss']
})
export class EditSeriesComponent implements OnInit {

  @Input() series: SeriesInstance;
  errorText: string = null;
  deleting: Boolean = false;

  seriesForm: FormGroup;
  seriesDescription: string = "";
  number: number;
  modality: string = "";

  showReset: Boolean = false;

  constructor(
    private fb: FormBuilder,
    private is: InstanceService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.initSeriesForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.initSeriesForm();
  }

  clearSeriesForm(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.seriesForm.reset();
    this.showReset = true;
  }

  initSeriesForm() {
    if (this.series) {
      this.seriesDescription = (this.series.description) ? this.series.description : "";
      this.number = (this.series.number) ? this.series.number : null;
      this.modality = (this.series.modality) ? this.series.modality : "";

      this.seriesForm = this.fb.group({
        seriesDescription: this.seriesDescription,
        number: this.number,
        modality: this.modality
      });
    }
  }

  applyForm(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.series.description = this.seriesForm.controls.seriesDescription.value;
    this.series.number = this.seriesForm.controls.number.value;
    this.series.modality = this.seriesForm.controls.modality.value;
    this.saveEdit();
  }

  
  saveEdit(): any {
    this.is.patientEditing$.emit(false);
    let patient = this.is.patients.find((p) => p.record_id == this.series.patient.record_id);
    let study = patient.studies.find((st) => st.record_id == this.series.study.record_id);
    let series = study.series.find((se) => se.record_id == this.series.record_id);
    series.editing = false;
    series.saving = true;

    this.is.updateSeriesAsOwner(this.series)
      .then((res) => {
        this.snackBar.open("Series Updated", null, {
          duration: 1000,
        });
      }).catch((err) => {
        this.errorText = err;
      });
  }

  closeEdit() {
    this.series.editing = false;
    this.series.editTemplate = false;
  }

  revertSeriesDescription() {
    this.seriesForm.controls.seriesDescription.setValue(this.seriesDescription);
  }

  revertModality() {
    this.seriesForm.controls.modality.setValue(this.modality);
  }

  revertNumber() {
    this.seriesForm.controls.number.setValue(this.number);
  }

  revertSeriesForm(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.showReset = false;
    this.initSeriesForm();
  }

}
